import React from "react";
import { Divider } from "@mui/material";
import { Wsm2023FinalsComponent } from "./Wsm2023FinalsComponent";
import { Wsm2026GroupsComponent } from "./Wsm2026GroupsComponent";


export const Wsm2026Component = () => {
	return (
		<>
			<Wsm2026GroupsComponent/>

			<Divider sx={{ my: 3 }}/>

			<Wsm2023FinalsComponent/>
		</>
	);
};
